/*
  <product-recommendations data-url="...">: requests recommendations from the
  product recommendations endpoint when the element comes near the viewport,
  then copies the matching element's content out of the rendered section.
  The element needs an id so it can be found in the response.
*/
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.loaded || this.observer || !this.dataset.url) return;

      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.stopObserving();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stopObserving();
    }

    stopObserving() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
    }

    async load() {
      this.loaded = true;
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = this.id ? page.getElementById(this.id) : page.querySelector('product-recommendations');
        if (source && source.children.length) this.replaceChildren(...source.childNodes);
      } catch (error) {
        /* recommendations are optional: the element simply stays empty */
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
